import { FC, ReactNode } from "react";

import { OrganizationPage } from "./OrganizationPage";
import { AppOrganizationPageProvider } from "./providers/AppOrganizationPageProvider";

import { useLoggedOrganization } from "@/common/hooks/useLoggedOrganization";
import { usePageScrollUp } from "@/common/hooks/usePageScrollUp";
import { OrganizationPageOutput } from "@/common/types/trpc";
// eslint-disable-next-line zeffy-linter-frontend/no-cross-layer-imports -- moved as is from the organization page route
import { ZeffyHead } from "@/components/Head/ZeffyHead";
// eslint-disable-next-line zeffy-linter-frontend/no-cross-layer-imports -- moved as is from the organization page route
import { ContainerLoader } from "@/components/Loaders/ContainerLoader";
// eslint-disable-next-line zeffy-linter-frontend/no-cross-layer-imports -- moved as is from the organization page route
import NotFoundWithProviders from "@/components/NotFound/NotFoundWithProviders";
import { useDynamicCanvasTheme } from "@/forms-design-system/Tokens/dynamicCanvasTheme";

interface OrganizationPageViewProps {
  organizationPage: OrganizationPageOutput;
  head: ReactNode;
}

export const OrganizationPageView: FC<OrganizationPageViewProps> = ({ organizationPage, head }) => {
  usePageScrollUp();
  const dynamicTheme = useDynamicCanvasTheme(organizationPage?.color, organizationPage.isDarkMode ? "dark" : "light");

  const { loggedOrganization, isReady } = useLoggedOrganization();
  const isPublished = organizationPage?.isPublished;
  const isOrganizationMember = loggedOrganization?.id === organizationPage.organizationId;

  if (!isPublished && !isReady) {
    return <ContainerLoader fullPage />;
  }

  if (!isPublished && !isOrganizationMember) {
    return (
      <>
        <ZeffyHead />
        <NotFoundWithProviders notFoundEntity="organization" />
      </>
    );
  }

  return (
    <>
      {head}
      <AppOrganizationPageProvider
        theme={dynamicTheme}
        organization={organizationPage.organization}
        fields={organizationPage.organizationPageFields || []}
        locale={organizationPage.locale}
      >
        <OrganizationPage organizationPage={organizationPage} isLoggedOrganization={!!isOrganizationMember} />
      </AppOrganizationPageProvider>
    </>
  );
};
